"use client";
import ReportDesigner, {
  RequestOptions,
} from "devexpress-reporting-react/dx-report-designer";
import "devextreme/dist/css/dx.light.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.common.css";
import "@devexpress/analytics-core/dist/css/dx-analytics.light.css";
import "devexpress-reporting/dist/css/dx-webdocumentviewer.css";
import "ace-builds/css/ace.css";
import "ace-builds/css/theme/dreamweaver.css";
import "ace-builds/css/theme/ambiance.css";
import "@devexpress/analytics-core/dist/css/dx-querybuilder.css";
import "devexpress-reporting/dist/css/dx-reportdesigner.css";

let baseURL = "";
if (window.location.hostname === "localhost") {
  baseURL = process.env.REACT_APP_API_BASE_URL_LOCAL || "http://localhost:3050";
} else {
  baseURL = process.env.REACT_APP_API_BASE_URL_WEB || "http://localhost:3050";
}

function ReportDesignerApp({ url }) {
  return (
    <ReportDesigner
      reportUrl={
        url ? (url !== "" ? url.split("/")[0] : "TestReport") : "TestReport"
      }
      onServerError={(error) => {
        return;
      }}
    >
      <RequestOptions
        host={baseURL + "/"}
        getDesignerModelAction="DXXRD/GetDesignerModel"
        invokeAction="DXXRD"
      />
    </ReportDesigner>
  );
}
export default ReportDesignerApp;
